export default "__VITE_ASSET__CHuVmT73__"